<template>
  <div class="card card-style mt-5 overflow-visible">
    <div class="content">
      <vue-skeleton-loader
        rounded
        :height="40"
        animation="fade"
        class="w-25 mt-2 mb-1 mx-auto"
      />
      <div class="d-flex justify-content-between">
        <vue-skeleton-loader
          :height="30"
          animation="fade"
          class="mt-1"
        />
        <vue-skeleton-loader
          :height="30"
          animation="fade"
          class="mt-1 ms-1"
        />
      </div>
      <vue-skeleton-loader
        rounded
        :height="40"
        animation="fade"
        class="w-25 mt-5 mb-1 mx-auto"
      />

      <div v-for="item in total_progres" :key="item" class="mb-3">
        <vue-skeleton-loader
          :height="20"
          animation="fade"
          class="mt-1 w-25"
        />
        <vue-skeleton-loader
          :height="20"
          animation="fade"
          class="mt-1 w-50"
        />
        <vue-skeleton-loader
          :height="20"
          animation="fade"
          class="mt-1 w-25"
        />
      </div>

      <table class="table table-bordered mt-2">
        <thead>
          <tr>
            <th>Disposisi Dari</th>
            <th>Tujuan</th>
            <th>Catatan</th>
            <th>Waktu</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in total_disposisi" :key="item">
            <td>
              <vue-skeleton-loader rounded height="20" animation="fade" class="mx-auto"/>
            </td>
            <td>
              <vue-skeleton-loader rounded height="20" animation="fade" class="mx-auto"/>
            </td>
            <td>
              <vue-skeleton-loader rounded height="20" animation="fade" class="mx-auto"/>
            </td>
            <td>
              <vue-skeleton-loader rounded height="20" animation="fade" class="mx-auto"/>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="table mt-2">
        <tbody>
          <tr v-for="item in total_table" :key="item">
            <td>
              <vue-skeleton-loader rounded height="20" animation="fade" class="w-100 mx-auto"/>
            </td>
            <td>
              <vue-skeleton-loader rounded height="20" animation="fade" class="w-100 mx-auto"/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
  
<script>
export default {
  props: {
    count: {
      default: 1,
      type: Number,
    }
  },
  data() {
    return {
      total_progres: 2,
      total_disposisi: 3,
      total_table: 7
    }
  }
};
</script>
  
<style scoped>
.desc {
  background-color: aqua;
  width: 150%;
}
</style>